import { getCurrentGlobalState } from '@app/setupRedux';
import { DEFAULT_SINGLE_EXPERIMENT_SAMPLE_SIZE } from '@/constants/configConstants';
import { BETA_FEATURE_INCREASE_SAMPLE_SIZE } from '@/lib/betaFeatures';
import { isBetaFeatureEnabled } from '@/reducers/betaFeaturesReducer';
import {
  DEFAULT_PANEL_GLOBAL_CONFIG,
  DEFAULT_PANEL_GLOBAL_CONFIG_CUSTOM_SAMPLE_SIZE,
  DEFAULT_PANELS,
  DEFAULT_VIEW
} from './view';

export const getDefaultPanelGlobalConfig = () => {
  const shouldIncreaseSampleSize = isBetaFeatureEnabled(
    getCurrentGlobalState(),
    {
      featureName: BETA_FEATURE_INCREASE_SAMPLE_SIZE
    }
  );

  if (!shouldIncreaseSampleSize) return DEFAULT_PANEL_GLOBAL_CONFIG;

  return DEFAULT_PANEL_GLOBAL_CONFIG_CUSTOM_SAMPLE_SIZE;
};

const DEFAULT_PANELS_CUSTOM_SAMPLE_SIZE = {
  ...DEFAULT_PANELS,
  config: DEFAULT_PANEL_GLOBAL_CONFIG_CUSTOM_SAMPLE_SIZE
};
export const getDefaultPanels = () => {
  const shouldIncreaseSampleSize = isBetaFeatureEnabled(
    getCurrentGlobalState(),
    {
      featureName: BETA_FEATURE_INCREASE_SAMPLE_SIZE
    }
  );

  if (!shouldIncreaseSampleSize) return DEFAULT_PANELS;

  return DEFAULT_PANELS_CUSTOM_SAMPLE_SIZE;
};

const DEFAULT_VIEW_CUSTOM_SAMPLE_SIZE = {
  ...DEFAULT_VIEW,
  panels: DEFAULT_PANELS_CUSTOM_SAMPLE_SIZE
};
export const getDefaultView = () => {
  const shouldIncreaseSampleSize = isBetaFeatureEnabled(
    getCurrentGlobalState(),
    {
      featureName: BETA_FEATURE_INCREASE_SAMPLE_SIZE
    }
  );

  if (!shouldIncreaseSampleSize) return DEFAULT_VIEW;

  return DEFAULT_VIEW_CUSTOM_SAMPLE_SIZE;
};

export const getDefaultExperimentPageSampleSize = () => {
  const shouldIncreaseSampleSize = isBetaFeatureEnabled(
    getCurrentGlobalState(),
    {
      featureName: BETA_FEATURE_INCREASE_SAMPLE_SIZE
    }
  );

  return shouldIncreaseSampleSize
    ? 2500
    : DEFAULT_SINGLE_EXPERIMENT_SAMPLE_SIZE;
};
